import { useAlert } from "hooks/alerts/useAlert";
import { useCallback, useState } from "react";
import { api } from "services/api.service";
import { locationInformationPayload } from "hooks/locations/locationInformationPayload";
import { LocationInformation } from "types/locationInformation";

interface SaveLocationInformationProps {
  locationUuid: string;
  locationInformation: LocationInformation;
  exists: boolean;
}

export default function useSaveLocationInformation() {
  const { alertError } = useAlert();
  const [isSaving, setIsSaving] = useState(false);

  const saveLocationInformation = useCallback(
    async ({ locationUuid, locationInformation, exists }: SaveLocationInformationProps) => {
      setIsSaving(true);

      try {
        const payload = { locationInformation: locationInformationPayload(locationInformation) };

        const response = exists
          ? await api.put<LocationInformation>(`/location_informations/${locationUuid}`, payload)
          : await api.post<LocationInformation>("/location_informations", { ...payload, locationUuid });

        return response.data;
      } catch {
        alertError("There was an error saving site information. Please try again.");
        throw new Error("Failed to save location information");
      } finally {
        setIsSaving(false);
      }
    },
    [alertError]
  );

  return {
    saveLocationInformation,
    isSaving,
  };
}
